export default __webpack_public_path__ + "static/media/images-solid.0428fee7.svg";